import type { NextPage } from "next";
import { useEffect } from "react";
import { useStores } from "../src/hooks/useStore";
import { redirectWithParams } from "../src/utils/redirect";
import LandingPage from "./landing";

const IndexPage: NextPage = () => {
  const { userStore } = useStores();

  useEffect(() => {
    if (!userStore.hasCheckedLogin) return;

    if (userStore.isLoggedIn) {
      redirectWithParams("/space");
    } else {
      const params = new URLSearchParams(window.location.search);
      if (params.has("join")) {
        redirectWithParams("/login");
      }
    }
  }, [userStore.hasCheckedLogin, userStore.isLoggedIn]);

  return <LandingPage />;
};

export default IndexPage;
